var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuteiconactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(40.75 -1483.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keypadicon",
    transform: "translate(-40.75 1483.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 27.25,
    cy: 27.25,
    r: 27.25,
    transform: "translate(0.75 0.75)",
    fill: "#fff",
    stroke: "#f3f7fb",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "mute",
    transform: "translate(-33.5 1490.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M20,27v3.061",
    transform: "translate(0.75 1.064)",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M17,30h6.123",
    transform: "translate(0.689 1.14)",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M16.36,12.408a4.077,4.077,0,0,1,7.8,1.674V20.2",
    transform: "translate(0.68 0.42)",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M12.25,12.25,28.068,28.068",
    transform: "translate(0.591 0.591)",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M16,16v4.082a4.081,4.081,0,0,0,6.968,2.886",
    transform: "translate(0.655 0.668)",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M27.111,19v.918a7.222,7.222,0,0,1-.536,2.729",
    transform: "translate(1.013 0.746)",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M12.9,19v.918A7.242,7.242,0,0,0,25.215,25.09",
    transform: "translate(0.576 0.799)",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteiconactive);
export default __webpack_public_path__ + "static/media/muteiconactive.3e12eedacd1be80320899bc951fe1371.svg";
export { ForwardRef as ReactComponent };